import type { EventDto } from 'api/generated';
export function GetColorByAvailability(event: EventDto | null | undefined) {
  if (event?.saleStatus === 'Cancelled') return 'action.disabled';
  if (event?.saleStatus === 'SoldOut') return 'error.main';
  if (event?.saleStatus === 'FewLeft') return 'warning.main';
  return 'success.main';
}
export function HighestAvailabilityEvent(events: EventDto[]) {
  const availableEvent = events.find(event => event.saleStatus === 'Available');
  if (availableEvent) return availableEvent;
  const fewLeftEvent = events.find(event => event.saleStatus === 'FewLeft');
  if (fewLeftEvent) return fewLeftEvent;
  const soldOutEvent = events.find(event => event.saleStatus === 'SoldOut');
  if (soldOutEvent) return soldOutEvent;
  return events[0];
}